import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { newPostsSlice } from './newPosts/slice';
import { previouslyViewedPostsMiddleware, previouslyViewedPostsSlice } from './previouslyViewedPosts/slice';
import { sortingMiddleware, sortingSlice } from './sorting/slice';
import { tabsSlice } from './tabs/slice';
import { usersSlice } from './user/slice';

const createReducer = (injectedReducers = {}) => {
  return combineReducers({
    user: usersSlice.reducer,
    newPosts: newPostsSlice.reducer,
    previouslyViewedPosts: previouslyViewedPostsSlice.reducer,
    tabs: tabsSlice.reducer,
    sorting: sortingSlice.reducer,
    ...injectedReducers,
  });
};

const store = configureStore({
  reducer: createReducer(),
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(previouslyViewedPostsMiddleware.middleware, sortingMiddleware.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
